import MockAdapter from "axios-mock-adapter";
import { URL_GET_CREDIT_CARD_STATEMENT, URL_GET_CREDIT_CARD_STATEMENTS } from "@/requests/finances";
import creditCardStatements from "./responses/creditCardStatements";
import creditCardStatement from "./responses/creditCardStatement";

export const financesMock = (mock: MockAdapter): void => {
  mock.onGet(URL_GET_CREDIT_CARD_STATEMENTS).reply(200, creditCardStatements);
  mock.onGet(URL_GET_CREDIT_CARD_STATEMENT).reply(200, creditCardStatement);
};
